/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import "react-h5-audio-player/lib/styles.css";
import { ToastContainer } from "react-toastify";
import TeamSelect from "../../Components/Common/TeamSelect";
import SelectOne from "../../Components/Common/SelectOne";
import { APIClient } from "../../helpers/api_helper";
import {
  getInitialDates,
  getPreviousCallAnalysisDate,
  setCurrentDate,
} from "../../Components/Common/DefaultDateSet";
import { HandleErrorMessage } from "../../Components/Common/HandleErrorMessage";
import { useProfileData } from "../../Components/Hooks/UserHooks";
import { Link, useNavigate } from "react-router-dom";
import SubExpired from "../../Components/Common/subExpired";
import CalculateRemainingDays from "../../Components/Common/CalculateRemainingDays";
import { UNIQUE_ClIENTS_EMPLOYEE_WISE_REPORT } from "../../helpers/url_helper";
import { toCamelCase } from "../../Components/Common/ToCamelCase";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import { DatePicker } from "../../Components/Common/Flatpicker";
import SelectDatePicker from "../DashboardCallCrm/DashboardAllFillter/selectDatePicker";
import { CommanDataTables } from "../../Components/Common/DashboardDataTbale";
import {
  getMonthDateRange,
  getMonthDisplay,
} from "../../Components/Common/FlatePicker";
import Toast from "../../Components/Common/Toast";
import { html } from "gridjs";
import { Grid, _ } from "gridjs-react";
const api = new APIClient();

const EmployeeWiseClientReport = () => {
  document.title = "UNIQUE CLIENT WISE REPORT";

  const permissionType = JSON.parse(localStorage.getItem("permission"));
  const viewReportPermission = permissionType?.includes("VIEW_REPORT");
  const loginType = JSON.parse(localStorage.getItem("logintype"));

  const { profileData } = useProfileData();
  const navigate = useNavigate();
  const [isExpiredModalOpen, setIsExpiredModalOpen] = useState(true);
  // default date
  const previewsDate = getPreviousCallAnalysisDate();
  const currentDate = setCurrentDate();
  const [selectionMode, setSelectionMode] = useState("month");

  const [selectedMonFromDate, setSelectedMonFromDate] = useState(previewsDate);
  const [selectedMonToDate, setSelectedMonToDate] = useState(currentDate);

  const [isLoading, setIsLoading] = useState(false);
  // filter data
  const [filterData, setFilteredData] = useState([]);
  // Pagination settings
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordingSummary, setRecordingSummary] = useState([]);
  // employee select
  const [selectedEmployeeOptions, setSelectedEmployeeOptions] = useState([]);
  const [selectedEmployeeOptions2, setSelectedEmployeeOptions2] = useState([]);
  const [query, setQuery] = useState("");

  // flatePicker Date
  const [selectedFromDates, setSelectedFromDates] = useState(getInitialDates());
  const [selectedToDates, setselectedToDates] = useState(getInitialDates());
  //select team state
  const [teamIndu, setTeamIndu] = useState([]);
  // summary show
  const [show, setShow] = useState(false);

  //team state
  const [getTableData, setGetTableData] = useState([]);
  const [EmployeeData, setEmployeeData] = useState([]);

  const [debouncedSearchText, setDebouncedSearchText] = useState("");

  const [appliedDateRange, setAppliedDateRange] = useState({
    startDate: previewsDate,
    endDate: currentDate,
    employeeIdPs: [],
  });

  const [getPeriodOne, setGetPeriodOne] = useState(false);
  const remainingDays = CalculateRemainingDays();
  const [open, setOpen] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");

  const showPeriodTwo = open === true && getPeriodOne === true;

  const transformedColumns = [
    {
      id: "clientPhoneNumber",
      name: "Client Name",
      sort: true,
      data: (row) => html(`
        <div>
          <span>${row.clientNames}</span>
          <br />
          <span>${row.clientphoneNumber}</span>
        </div>`
      ),
    },

    {
      name: html(
        `<div style="text-align:center;font-weight:bold;">${recordingSummary?.summary?.period1Summary?.dateRange}</div>`
      ),
      columns: [
        {
          id: "totalPeriodOneCall",
          name: "Total Call",
          sort: true,
          data: (row) => row.totalPeriodOneCall,
          formatter: (val) =>
            html(`<div style="text-align:center">${val}</div>`),
        },
        {
          id: "periodOneoutgoing",
          name: "Outgoing",
          sort: true,
          data: (row) => row.periodOneoutgoing,
          formatter: (val) =>
            html(`<div style="text-align:center">${val}</div>`),
        },
        {
          id: "periodOneincoming",
          name: "Incoming",
          sort: true,
          data: (row) => row.periodOneincoming,
          formatter: (val) =>
            html(`<div style="text-align:center">${val}</div>`),
        },
        {
          id: "periodOnemissed",
          name: "Missed",
          sort: true,
          data: (row) => row.periodOnemissed,
          formatter: (val) =>
            html(`<div style="text-align:center">${val}</div>`),
        },
        {
          id: "periodOnerejected",
          name: "Rejected",
          sort: true,
          data: (row) => row.periodOnerejected,
          formatter: (val) =>
            html(`<div style="text-align:center">${val}</div>`),
        },
      ],
    },

    ...(showPeriodTwo
      ? [
          {
            name: html(
              `<div style="text-align:center;font-weight:bold;">${recordingSummary?.summary?.period2Summary?.dateRange}</div>`
            ),
            columns: [
              {
                id: "totalPeriodTwoCall",
                name: "Total Call",
                sort: true,
                data: (row) => row.totalPeriodTwoCall,
                formatter: (val) =>
                  html(`<div style="text-align:center">${val}</div>`),
              },
              {
                id: "periodTwooutgoing",
                name: "Outgoing",
                sort: true,
                data: (row) => row.periodTwooutgoing,
                formatter: (val) =>
                  html(`<div style="text-align:center">${val}</div>`),
              },
              {
                id: "periodTwoincoming",
                name: "Incoming",
                sort: true,
                data: (row) => row.periodTwoincoming,
                formatter: (val) =>
                  html(`<div style="text-align:center">${val}</div>`),
              },
              {
                id: "periodTwomissed",
                name: "Missed",
                sort: true,
                data: (row) => row.periodTwomissed,
                formatter: (val) =>
                  html(`<div style="text-align:center">${val}</div>`),
              },
              {
                id: "periodTworejected",
                name: "Rejected",
                sort: true,
                data: (row) => row.periodTworejected,
                formatter: (val) =>
                  html(`<div style="text-align:center">${val}</div>`),
              },
            ],
          },
        ]
      : []),

    ...(showPeriodTwo
      ? [
          {
            name: html(
              `<div style="text-align:center; font-weight:bold;">Difference</div>`
            ),
            columns: [
              {
                id: "differenceTotal",
                name: "Total Calls",
                sort: true,
                data: (row) => row.differenceTotal,
                formatter: (val, row) => {
                  const percent = row.totalChangeClass ?? 0;
                  const color = percent >= 0 ? "green" : "red";
                  return html(`<div style="text-align:center;">
          ${val ?? "N/A"}<br/>
          <span style="color:${color}; font-size:12px">(${percent}%)</span>
        </div>`);
                },
              },
              {
                id: "differenceOutgoing",
                name: "Outgoing",
                sort: true,
                data: (row) => row.differenceOutgoing,
                formatter: (val, row) => {
                  const percent = row.ougoingChangeClass ?? 0;
                  const color = percent >= 0 ? "green" : "red";
                  return html(`<div style="text-align:center;">
          ${val ?? "N/A"}<br/>
          <span style="color:${color}; font-size:12px">(${percent}%)</span>
        </div>`);
                },
              },
              {
                id: "differenceIncoming",
                name: "Incoming",
                sort: true,
                data: (row) => row.differenceIncoming,
                formatter: (val, row) => {
                  const percent = row.incomigChangeClass ?? 0;
                  const color = percent >= 0 ? "green" : "red";
                  return html(`<div style="text-align:center;">
          ${val ?? "N/A"}<br/>
          <span style="color:${color}; font-size:12px">(${percent}%)</span>
        </div>`);
                },
              },
              {
                id: "differenceMissed",
                name: "Missed",
                sort: true,
                data: (row) => row.differenceMissed,
                formatter: (val, row) => {
                  const percent = row.missedChangeClass ?? 0;
                  const color = percent >= 0 ? "green" : "red";
                  return html(`<div style="text-align:center;">
          ${val ?? "N/A"}<br/>
          <span style="color:${color}; font-size:12px">(${percent}%)</span>
        </div>`);
                },
              },
              {
                id: "differenceReject",
                name: "Rejected",
                sort: true,
                data: (row) => row.differenceReject,
                formatter: (val, row) => {
                  const percent = row.rejectChangeClass ?? 0;
                  const color = percent >= 0 ? "green" : "red";
                  return html(`<div style="text-align:center;">
          ${val ?? "N/A"}<br/>
          <span style="color:${color}; font-size:12px">(${percent}%)</span>
        </div>`);
                },
              },
            ],
          },
        ]
      : []),
  ];


  // search field
  const handleSearch = (e) => {
    setQuery(e.target.value);
  };

  // From Month Handler
  const handleMonFromDateChange = (selectedDates) => {
    const date = selectedDates[0];
    setSelectedMonFromDate(date);
  };

  // To Month Handler
  const handleMonToDateChange = (selectedDates) => {
    const date = selectedDates[0];
    setSelectedMonToDate(date);
  };

  const formattedDatesOne = useMemo(
    () => ({
      startDate: selectedFromDates[0].format("YYYY-MM-DD"),
      endDate: selectedFromDates[1].format("YYYY-MM-DD"),
    }),
    [selectedFromDates]
  );

  const formattedDatesTwo = useMemo(
    () => ({
      startDate: selectedToDates[0].format("YYYY-MM-DD"),
      endDate: selectedToDates[1].format("YYYY-MM-DD"),
    }),
    [selectedToDates]
  );

  const handleUniqueClientSubmit = () => {
    // Enhanced validation for employee selection
    const employeeIds = selectedEmployeeOptions?.id;

    if (!employeeIds || employeeIds.length === 0) {
      Toast("Please select at least one employee", "error");
      return;
    }

    let dateObj;

    if (selectionMode === "month") {
      // Validate month selection
      if (!selectedMonFromDate) {
        Toast("Please select Comparison 'From month'", "error");
        return;
      }
      if (!selectedMonToDate && getPeriodOne === true) {
        Toast("Please select Comparison 'To month'", "error");
        return;
      }

      // For month mode, you might want to validate both dates or handle single month
      const sDate1 = getMonthDateRange(selectedMonFromDate);
      const sDate2 = selectedMonToDate
        ? getMonthDateRange(selectedMonToDate)
        : null;

      // Check if date range calculation was successful
      if (!sDate1) {
        alert("Invalid start month selected");
        return;
      }

      dateObj = {
        startDate1: sDate1.startDate,
        endDate1: sDate1.endDate,
        startDate2: sDate2?.startDate || null,
        endDate2: sDate2?.endDate || null,
        employeeIds: employeeIds,
      };
    } else {
      // Validate date range selection
      if (!formattedDatesOne?.startDate || !formattedDatesOne?.endDate) {
        alert("Please select a valid date range");
        return;
      }

      dateObj = {
        startDate1: formattedDatesOne.startDate,
        endDate1: formattedDatesOne.endDate,
        startDate2: formattedDatesTwo?.startDate || null,
        endDate2: formattedDatesTwo?.endDate || null,
        employeeIds: employeeIds,
      };
    }

    // Additional validation: Check if dates are valid
    if (!dateObj.startDate1 || !dateObj.endDate1) {
      alert("Please ensure all required dates are selected");
      return;
    }

    // Execute the main logic
    try {
      if (getPeriodOne === true) {
        setAppliedDateRange(dateObj);
        getUniqueClientData(dateObj, getPeriodOne);
        setSelectedEmployeeOptions2(selectedEmployeeOptions);
        setCurrentPage(1);
        setPerPage(10);
        setOpen(true);
      } else {
        setAppliedDateRange(dateObj);
        getUniqueClientData(dateObj, "");
        setSelectedEmployeeOptions2(selectedEmployeeOptions);
        setCurrentPage(1);
        setPerPage(10);
      }
    } catch (error) {
      console.error("Error processing data:", error);
      alert("An error occurred while processing your request");
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      if (query.length >= 3) {
        setDebouncedSearchText(query);
      } else {
        setDebouncedSearchText("");
      }
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [query]);

  // Pagination handlers
  const handlePerRowsChange = (newPerPage) => setPerPage(newPerPage);
  const handlePageChange = (page) => setCurrentPage(page);
  const handleComaparisionModeChange = (e) => setGetPeriodOne(e.target.checked);

  // getRecording api

  const getUniqueClientData = useCallback(
    async (dateObj, type) => {
      setIsLoading(true);
      try {
        let data = {
          startDate1: dateObj?.startDate1,
          endDate1: dateObj?.endDate1,
          startDate2: type === true ? dateObj?.startDate2 : dateObj?.startDate1,
          endDate2: type === true ? dateObj?.endDate2 : dateObj?.endDate1,
          employeeId: dateObj?.employeeIds,
        };

        const response = await api.create(
          `${UNIQUE_ClIENTS_EMPLOYEE_WISE_REPORT}`,
          data
        );
        if (response && response.success === true) {
          const apiResponse = response.data;
          setRecordingSummary(apiResponse);
          setShow(true);
          setTotalRows(apiResponse.totalRecordCount);
          const tableData = (apiResponse?.uniqueClients || []).map((data) => {
            console.log(data.period1?.phoneNumber);

            return {
              clientNames: data.clientName || "unknown",
              clientphoneNumber:
                data.period1?.phoneNumber || data.period2?.phoneNumber,
              totalPeriodOneCall: data?.period1?.total,
              totalPeriodTwoCall: data?.period2?.total,
              periodOneoutgoing: data?.period1?.outgoing,
              periodOneincoming: data?.period1?.incoming,
              periodOnemissed: data?.period1?.missed,
              periodOnerejected: data?.period1?.rejected,
              periodTwooutgoing: data?.period2?.outgoing,
              periodTwoincoming: data?.period2?.incoming,
              periodTwomissed: data?.period2?.missed,
              periodTworejected: data?.period2?.rejected,
              differenceTotal: data?.difference.total,
              differenceOutgoing: data?.difference.outgoing,
              differenceIncoming: data?.difference.incoming,
              differenceMissed: data?.difference.missed,
              differenceReject: data?.difference.rejected,
              asmName: data.asmName || "unknown",
              callCounts: data.callCounts || "-",
              totalChangeClass: data?.percentageChange?.total,
              ougoingChangeClass: data?.percentageChange?.outgoing,
              incomigChangeClass: data?.percentageChange?.outgoing,
              missedChangeClass: data?.percentageChange?.outgoing,
              rejectChangeClass: data?.percentageChange?.outgoing,
            };
          });
          setGetTableData(tableData);
          const totalCount = tableData.length || 0;
          setTotalRows(totalCount);
        }
      } catch (error) {
        if (!remainingDays === 0) {
          HandleErrorMessage(error);
        }
      } finally {
        setIsLoading(false);
      }
    },
    [
      formattedDatesOne,
      formattedDatesTwo,
      selectedEmployeeOptions,
      selectedEmployeeOptions2,
      currentPage,
      EmployeeData,
      perPage,
      appliedDateRange,
    ]
  );

  // clear field in button
  const handleReset = () => {
    setSelectedEmployeeOptions([]);
    setTeamIndu([]);
  };

  const handleClose = () => {
    setIsExpiredModalOpen(false);
    navigate("/planPackage");
  };

  const handleSelectionModeChange = (e) => {
    setSelectionMode(e.target.value);

    // Reset fields and API data
    setSelectedMonFromDate(null);
    setSelectedMonToDate(null);
    setSelectedFromDates(getInitialDates());
    setselectedToDates(getInitialDates());

    setGetTableData([]);
    setRecordingSummary([]);
    setFilteredData([]);
    setQuery("");
    setDebouncedSearchText("");
    setShow(false);

    setAppliedDateRange({
      startDate: null,
      endDate: null,
      employeeIds: [],
    });
  };

  const monthPeriod1Name = getMonthDisplay(
    recordingSummary?.filters?.period1?.startDate
  );

  const monthPeriod2Name = getMonthDisplay(
    recordingSummary?.filters?.period2?.startDate
  );

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    const filtered = (getTableData || []).filter((item) =>
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(searchQuery.toLowerCase())
      )
    );

    setFilteredData(filtered);
  }, [getTableData, searchQuery]);

  return (
    <React.Fragment>
      <ToastContainer />
      {remainingDays === 0 && isExpiredModalOpen && (
        <SubExpired
          onClose={handleClose}
          profileData={profileData?.selectedPlanDetails?.planName}
          remainingDays={remainingDays}
        />
      )}
      <div className="page-content sn-recording-report-page">
        <Container fluid>
          <BreadCrumb
            title="Employee-Wise Client Call Comparison Report"
            pageTitle="UNIQUE CLIENT WISE REPORT"
          />

          <Row>
            <Col lg={12}>
              <Card className="h-100">
                <CardBody>
                  <Row className="sn-header-select-employess-home sn-top-inputs-heading">
                    <div className="p-4 rounded-lg mb-6">
                      <div
                        className="flex gap-6 radio-group-sn"
                        style={{ display: "flex", gap: "23px" }}
                      >
                        <label className="flex items-center gap-2 cursor-pointer radio-option-sn">
                          <input
                            type="radio"
                            name="selectionMode"
                            value="month"
                            checked={selectionMode === "month"}
                            onChange={handleSelectionModeChange}
                            className="text-blue-500"
                          />
                          <span className="text-sm">Select Month</span>
                        </label>
                        <label className="flex items-center gap-0 cursor-pointer radio-option-sn">
                          <input
                            type="radio"
                            name="selectionMode"
                            value="date"
                            checked={selectionMode === "date"}
                            onChange={handleSelectionModeChange}
                            className="text-blue-500"
                          />
                          <span className="text-sm">Select Date</span>
                        </label>
                        <label className="flex items-center gap-2 cursor-pointer radio-option-sn">
                          <input
                            type="checkBox"
                            name="selectionMode"
                            value="Comparision"
                            checked={getPeriodOne}
                            onChange={handleComaparisionModeChange}
                            className="text-blue-500"
                          />
                          <span className="text-sm">Comparision</span>
                        </label>
                      </div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xs-12">
                      <div className="sn-call-summary-date-picker">
                        {selectionMode === "month" ? (
                          <>
                            <DatePicker
                              labelContent="From Month"
                              getDate={selectedMonFromDate}
                              options={{
                                plugins: [
                                  new monthSelectPlugin({
                                    shorthand: true,
                                    dateFormat: "F, Y",
                                    theme: "light",
                                  }),
                                ],
                                maxDate: new Date(),
                              }}
                              onChange={handleMonFromDateChange}
                            />
                          </>
                        ) : (
                          <>
                            <Label for="exampleDate">From Date</Label>
                            <SelectDatePicker
                              className="border"
                              selectedDates={selectedFromDates}
                              setSelectedDates={setSelectedFromDates}
                            />
                          </>
                        )}
                      </div>
                    </div>

                    {getPeriodOne === false ? (
                      ""
                    ) : (
                      <>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xs-12">
                          <div className="sn-call-summary-date-picker">
                            {selectionMode === "month" ? (
                              <>
                                <DatePicker
                                  labelContent="To Month"
                                  getDate={selectedMonToDate}
                                  options={{
                                    plugins: [
                                      new monthSelectPlugin({
                                        shorthand: true,
                                        dateFormat: "F, Y",
                                        theme: "light",
                                      }),
                                    ],
                                    maxDate: new Date(),
                                  }}
                                  onChange={handleMonToDateChange}
                                />
                              </>
                            ) : (
                              <>
                                <Label for="exampleDate">To Date</Label>
                                <SelectDatePicker
                                  className="border"
                                  selectedDates={selectedToDates}
                                  setSelectedDates={setselectedToDates}
                                />
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    )}

                    {/* <div className="col-md-3 col-sm-12 sn-header-select-employess-home"> */}
                    {/* {((viewReportPermission && loginType === "employee") ||
                        loginType === "organization") && ( */}
                    <div className="col-md-2 col-sm-12">
                      <TeamSelect
                        setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                        teamIndu={teamIndu}
                        setTeamIndu={setTeamIndu}
                        labelContent="Select Team"
                      />
                    </div>
                    {/* )} */}
                    {/* </div> */}

                    <div className="col-md-2 col-sm-12">
                      {/* {((viewReportPermission && loginType === "employee") ||
                      loginType === "organization") && ( */}
                      <SelectOne
                        setEmployeeData={setEmployeeData}
                        EmployeeData={EmployeeData}
                        teamIndu={teamIndu}
                        selectedEmployeeOptions={selectedEmployeeOptions}
                        setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                        labelContent="Select Employee"
                      />
                      {/* )} */}
                    </div>

                    <div className="col-md-3 col-sm-12">
                      <FormGroup className="mt-2">
                        <Label for="exampleSelect"></Label>
                        <div
                          id="exampleSelect"
                          className="sn-call-apply-btn-reset"
                        >
                          <Button
                            id="exampleSelect"
                            type="submit"
                            color="danger"
                            className=""
                            onClick={handleUniqueClientSubmit}
                          >
                            Apply
                          </Button>
                          <Button
                            className="mr-4"
                            style={{ marginLeft: "10px" }}
                            id="exampleSelect"
                            outline
                            color="danger"
                            onClick={handleReset}
                          >
                            Reset
                          </Button>
                        </div>
                      </FormGroup>
                    </div>
                  </Row>

                  {show === true ? (
                    <>
                      <Row>
                        <Col xxl={12} className="p-0">
                          <CardBody>
                            <>
                              <div>
                                <h4
                                  style={{
                                    fontSize: "medium",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Employee-wise Summary
                                </h4>
                              </div>
                              <div
                                className="col-md-12"
                                style={{ marginBottom: "20px" }}
                              >
                                <div className="table-responsive bg-light sn-wise-div-box-min">
                                  <div className="table-responsive">
                                    <Table
                                      className="table-bordered align-middle table-nowrap mb-0"
                                      style={{
                                        background: "#fff",
                                        textAlign: "center",
                                      }}
                                    >
                                      <thead>
                                        <tr
                                          style={{
                                            background: "rgb(255, 242, 242)",
                                          }}
                                        >
                                          <th
                                            scope="col"
                                            style={{ fontSize: "15px" }}
                                          >
                                            Metric
                                          </th>
                                          <th scope="col">
                                            <div
                                              className=""
                                              style={{ fontSize: "15px" }}
                                            >
                                              <strong>Period 1:</strong>{" "}
                                              <span className="text-danger">
                                                {selectionMode === "month"
                                                  ? monthPeriod1Name
                                                  : recordingSummary?.summary
                                                      ?.period1Summary
                                                      ?.dateRange}
                                              </span>
                                            </div>
                                          </th>

                                          {showPeriodTwo === false ? (
                                            ""
                                          ) : (
                                            <>
                                              {" "}
                                              <th scope="col">
                                                <div
                                                  className=""
                                                  style={{ fontSize: "15px" }}
                                                >
                                                  <strong>Period 2:</strong>{" "}
                                                  <span className="text-danger">
                                                    {selectionMode === "month"
                                                      ? monthPeriod2Name
                                                      : recordingSummary
                                                          ?.summary
                                                          ?.period2Summary
                                                          ?.dateRange}
                                                  </span>
                                                </div>
                                              </th>{" "}
                                              <th
                                                scope="col"
                                                style={{ fontSize: "15px" }}
                                              >
                                                Difference
                                              </th>
                                              <th
                                                scope="col"
                                                style={{ fontSize: "15px" }}
                                              >
                                                % Change
                                              </th>
                                            </>
                                          )}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td className="fw-medium">
                                            <div>
                                              <i
                                                className="ri-phone-fill"
                                                style={{
                                                  color: "#6f6fb1f5",
                                                  position: "relative",
                                                  top: "5px",
                                                  fontSize: "16px",
                                                }}
                                              ></i>
                                              <span
                                                className="badge badge-soft-warning sn-out-total-wise-call sn-client-wise-bg-none"
                                                style={{ fontSize: "14px" }}
                                              >
                                                {" "}
                                                TOTAL CALL{" "}
                                              </span>
                                            </div>
                                          </td>

                                          <td style={{ textAlign: "center" }}>
                                            <div className="sn-total-callbg an-client-wise-data-main">
                                              <div
                                                className=""
                                                style={{ textAlign: "center" }}
                                              >
                                                {
                                                  recordingSummary?.summary
                                                    ?.period1Summary?.total
                                                }
                                              </div>
                                            </div>
                                          </td>

                                          {showPeriodTwo === false ? (
                                            ""
                                          ) : (
                                            <>
                                              {" "}
                                              <td>
                                                <div className="sn-total-callbg an-client-wise-data-main">
                                                  {" "}
                                                  <div className="">
                                                    {
                                                      recordingSummary?.summary
                                                        ?.period2Summary?.total
                                                    }
                                                  </div>
                                                </div>
                                              </td>
                                            </>
                                          )}

                                          {showPeriodTwo === false ? (
                                            ""
                                          ) : (
                                            <>
                                              <td>
                                                <div className="negative-change ">
                                                  {
                                                    recordingSummary?.summary
                                                      ?.overallDifference?.total
                                                  }
                                                </div>
                                              </td>
                                            </>
                                          )}

                                          {showPeriodTwo === false ? (
                                            ""
                                          ) : (
                                            <>
                                              <td>
                                                <div
                                                  className={`fs-13 fw-medium mb-0 text-${
                                                    recordingSummary?.summary
                                                      ?.overallPercentageChange
                                                      ?.total >= 0
                                                      ? "success"
                                                      : "danger"
                                                  }`}
                                                >
                                                  (
                                                  {
                                                    recordingSummary?.summary
                                                      ?.overallPercentageChange
                                                      ?.total
                                                  }
                                                  %)
                                                </div>
                                              </td>
                                            </>
                                          )}
                                        </tr>

                                        <tr>
                                          <td className="fw-medium">
                                            {" "}
                                            <div>
                                              {" "}
                                              <i className="mdi mdi-phone-outgoing sn-out-going-text"></i>{" "}
                                              <span
                                                className="badge badge-soft-info sn-out-going-call sn-client-wise-bg-none"
                                                style={{ fontSize: "14px" }}
                                              >
                                                {" "}
                                                OUTGOING
                                              </span>
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sn-total-outgoing-callbg an-client-wise-data-main">
                                              <div className="">
                                                {
                                                  recordingSummary?.summary
                                                    ?.period1Summary?.outgoing
                                                }
                                              </div>
                                            </div>
                                          </td>

                                          {showPeriodTwo === false ? (
                                            ""
                                          ) : (
                                            <>
                                              {" "}
                                              <td>
                                                {" "}
                                                <div className="sn-total-outgoing-callbg an-client-wise-data-main">
                                                  <div className="">
                                                    {
                                                      recordingSummary?.summary
                                                        ?.period2Summary
                                                        ?.outgoing
                                                    }
                                                  </div>
                                                </div>
                                              </td>{" "}
                                            </>
                                          )}

                                          {showPeriodTwo === false ? (
                                            ""
                                          ) : (
                                            <>
                                              <td>
                                                {" "}
                                                <div className="negative-change">
                                                  {
                                                    recordingSummary?.summary
                                                      ?.overallDifference
                                                      ?.outgoing
                                                  }
                                                </div>
                                              </td>
                                            </>
                                          )}

                                          {showPeriodTwo === false ? (
                                            ""
                                          ) : (
                                            <>
                                              <td>
                                                <div
                                                  className={`fs-13 fw-medium mb-0 text-${
                                                    recordingSummary?.summary
                                                      ?.overallPercentageChange
                                                      ?.outgoing >= 0
                                                      ? "success"
                                                      : "danger"
                                                  }`}
                                                >
                                                  {
                                                    recordingSummary?.summary
                                                      ?.overallPercentageChange
                                                      ?.outgoing
                                                  }
                                                  %
                                                </div>
                                              </td>
                                            </>
                                          )}
                                        </tr>

                                        <tr>
                                          <td className="fw-medium">
                                            <div>
                                              <i className="mdi mdi-phone-incoming text-success"></i>
                                              <span
                                                className="badge badge-soft-success sn-out-incoming-call sn-client-wise-bg-none"
                                                style={{ fontSize: "14px" }}
                                              >
                                                {" "}
                                                INCOMING{" "}
                                              </span>
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sn-total-incoming-callbg an-client-wise-data-main">
                                              {" "}
                                              <div className="">
                                                {
                                                  recordingSummary?.summary
                                                    ?.period1Summary?.incoming
                                                }
                                              </div>
                                            </div>
                                          </td>

                                          {showPeriodTwo === false ? (
                                            ""
                                          ) : (
                                            <>
                                              <td>
                                                <div className="sn-total-incoming-callbg an-client-wise-data-main">
                                                  <div className="">
                                                    {
                                                      recordingSummary?.summary
                                                        ?.period2Summary
                                                        ?.incoming
                                                    }
                                                  </div>
                                                </div>
                                              </td>
                                            </>
                                          )}

                                          {showPeriodTwo === false ? (
                                            ""
                                          ) : (
                                            <>
                                              <td>
                                                {" "}
                                                <div className="negative-change">
                                                  {
                                                    recordingSummary?.summary
                                                      ?.overallDifference
                                                      ?.incoming
                                                  }
                                                </div>
                                              </td>
                                            </>
                                          )}

                                          {showPeriodTwo === false ? (
                                            ""
                                          ) : (
                                            <>
                                              <td>
                                                <div>
                                                  <div
                                                    className={`fs-13 fw-medium mb-0 text-${
                                                      recordingSummary?.summary
                                                        ?.overallPercentageChange
                                                        ?.incoming >= 0
                                                        ? "success"
                                                        : "danger"
                                                    }`}
                                                  >
                                                    {
                                                      recordingSummary?.summary
                                                        ?.overallPercentageChange
                                                        ?.incoming
                                                    }
                                                    %
                                                  </div>
                                                </div>
                                              </td>
                                            </>
                                          )}
                                        </tr>

                                        <tr>
                                          <td className="fw-medium">
                                            <div>
                                              <i className="mdi mdi-phone-missed sn-out-missed-text"></i>
                                              <span
                                                className="badge badge-soft-danger sn-out-missed-call sn-client-wise-bg-none"
                                                style={{ fontSize: "14px" }}
                                              >
                                                {" "}
                                                MISSED{" "}
                                              </span>
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sn-total-missed-callbg an-client-wise-data-main">
                                              <div className="">
                                                {
                                                  recordingSummary?.summary
                                                    ?.period1Summary?.missed
                                                }
                                              </div>
                                            </div>
                                          </td>

                                          {showPeriodTwo === false ? (
                                            ""
                                          ) : (
                                            <>
                                              <td>
                                                <div className="sn-total-missed-callbg an-client-wise-data-main">
                                                  {" "}
                                                  <div className="">
                                                    {
                                                      recordingSummary?.summary
                                                        ?.period2Summary?.missed
                                                    }
                                                  </div>
                                                </div>
                                              </td>{" "}
                                            </>
                                          )}

                                          {showPeriodTwo === false ? (
                                            ""
                                          ) : (
                                            <>
                                              <td>
                                                <div className="negative-change">
                                                  {
                                                    recordingSummary?.summary
                                                      ?.overallDifference
                                                      ?.missed
                                                  }
                                                </div>
                                              </td>
                                            </>
                                          )}

                                          {showPeriodTwo === false ? (
                                            ""
                                          ) : (
                                            <>
                                              <td>
                                                {" "}
                                                <div
                                                  className={`fs-13 fw-medium mb-0 text-${
                                                    recordingSummary?.summary
                                                      ?.overallPercentageChange
                                                      ?.missed >= 0
                                                      ? "success"
                                                      : "danger"
                                                  }`}
                                                >
                                                  (
                                                  {
                                                    recordingSummary?.summary
                                                      ?.overallPercentageChange
                                                      ?.missed
                                                  }
                                                  %)
                                                </div>
                                              </td>
                                            </>
                                          )}
                                        </tr>

                                        <tr>
                                          <td className="fw-medium">
                                            <div>
                                              <i className="mdi mdi-phone-remove sn-out-rejected-text"></i>
                                              <span
                                                className="badge badge-soft-warning sn-out-rejected-call sn-client-wise-bg-none"
                                                style={{ fontSize: "14px" }}
                                              >
                                                {" "}
                                                REJECTED{" "}
                                              </span>
                                            </div>
                                          </td>
                                          <td>
                                            <div className="sn-total-rejected-callbg an-client-wise-data-main">
                                              <div className="">
                                                {
                                                  recordingSummary?.summary
                                                    ?.period1Summary?.rejected
                                                }
                                              </div>
                                            </div>
                                          </td>

                                          {showPeriodTwo === false ? (
                                            ""
                                          ) : (
                                            <>
                                              <td>
                                                <div className="sn-total-rejected-callbg an-client-wise-data-main">
                                                  {" "}
                                                  <div className="">
                                                    {
                                                      recordingSummary?.summary
                                                        ?.period2Summary
                                                        ?.rejected
                                                    }
                                                  </div>
                                                </div>
                                              </td>

                                              <td>
                                                {" "}
                                                <div className=" negative-change">
                                                  {
                                                    recordingSummary?.summary
                                                      ?.overallDifference
                                                      ?.rejected
                                                  }
                                                </div>
                                              </td>
                                              <td>
                                                <div
                                                  className={`fs-13 fw-medium mb-0 text-${
                                                    recordingSummary?.summary
                                                      ?.overallPercentageChange
                                                      ?.rejected >= 0
                                                      ? "success"
                                                      : "danger"
                                                  }`}
                                                >
                                                  (
                                                  {
                                                    recordingSummary?.summary
                                                      ?.overallPercentageChange
                                                      ?.rejected
                                                  }
                                                  %)
                                                </div>
                                              </td>
                                            </>
                                          )}
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="table-responsive bg-light sn-wise-div-box-min"
                                style={{ display: "none" }}
                              >
                                <div className="row">
                                  {/* Period 1 */}
                                  <div className="col-lg-6 mb-4">
                                    <div
                                      className="period-header"
                                      style={{ fontSize: "150px" }}
                                    >
                                      <i className="fas fa-check-square checkbox-icon" />
                                      <strong>Period 1:</strong>{" "}
                                      <span className="text-danger">
                                        {selectionMode === "month"
                                          ? monthPeriod1Name
                                          : recordingSummary?.summary
                                              ?.period1Summary?.dateRange}
                                      </span>
                                    </div>
                                    <div className="sn-client-overall-change1">
                                      <div className="row">
                                        <div className="col-md-12">
                                          <div className="row">
                                            <div className="">
                                              <div
                                                className="sn-client-wise-total-data"
                                                style={{}}
                                              >
                                                <div className="sn-client-wise-icon-box-">
                                                  <div>
                                                    <div
                                                      className="stat-number text-info"
                                                      style={{
                                                        marginTop: "50px",
                                                        display: "inline-block",
                                                      }}
                                                    >
                                                      {
                                                        recordingSummary
                                                          ?.summary
                                                          ?.period1Summary
                                                          ?.total
                                                      }
                                                    </div>
                                                    <p className="stat-label">
                                                      Total
                                                    </p>
                                                  </div>

                                                  {/* <div>
                                                                                            <div className="sn-client-wise-icon-outgoing snclient-wise-total">
                                                                                                <i className="ri-space-ship-line"></i>
                                                                                            </div>
                                                                                        </div> */}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          {/* Outgoing */}
                                          <div className="row">
                                            {/* Total */}

                                            <div className="col-md-6 col-sm-6">
                                              <div
                                                className="stat-card bg-white- outgoing-border-"
                                                style={{}}
                                              >
                                                <div className="sn-client-wise-icon-box">
                                                  <div>
                                                    <p className="stat-label">
                                                      Outgoing
                                                    </p>
                                                    <div className="stat-number text-success">
                                                      {
                                                        recordingSummary
                                                          ?.summary
                                                          ?.period1Summary
                                                          ?.outgoing
                                                      }
                                                    </div>
                                                  </div>
                                                  <div>
                                                    <div className="sn-client-wise-icon-outgoing snclient-wise-outgoing">
                                                      <i className="ri-space-ship-line"></i>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            {/* Incoming */}
                                            <div className="col-md-6 col-sm-6">
                                              <div
                                                className="stat-card bg-white- incoming-border-"
                                                style={{}}
                                              >
                                                <div className="sn-client-wise-icon-box">
                                                  <div>
                                                    <p className="stat-label">
                                                      Incoming
                                                    </p>
                                                    <div className="stat-number text-primary">
                                                      {
                                                        recordingSummary
                                                          ?.summary
                                                          ?.period1Summary
                                                          ?.incoming
                                                      }
                                                    </div>
                                                  </div>

                                                  <div>
                                                    <div className="sn-client-wise-icon-outgoing snclient-wise-incoming">
                                                      <i className="ri-space-ship-line"></i>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            {/* Missed */}
                                            <div className="col-md-6 col-sm-6">
                                              <div
                                                className="stat-card bg-white- missed-border-"
                                                style={{}}
                                              >
                                                <div className="sn-client-wise-icon-box">
                                                  <div>
                                                    <p className="stat-label">
                                                      Missed
                                                    </p>
                                                    <div className="stat-number text-danger">
                                                      {
                                                        recordingSummary
                                                          ?.summary
                                                          ?.period1Summary
                                                          ?.missed
                                                      }
                                                    </div>
                                                  </div>

                                                  <div>
                                                    <div className="sn-client-wise-icon-outgoing snclient-wise-missed">
                                                      <i className="ri-space-ship-line"></i>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                              <div
                                                className="stat-card bg-white- rejected-border-"
                                                style={{}}
                                              >
                                                <div className="sn-client-wise-icon-box">
                                                  <div>
                                                    <p className="stat-label">
                                                      Rejected
                                                    </p>
                                                    <div className="stat-number text-muted">
                                                      {
                                                        recordingSummary
                                                          ?.summary
                                                          ?.period1Summary
                                                          ?.rejected
                                                      }
                                                    </div>
                                                  </div>

                                                  <div>
                                                    <div className="sn-client-wise-icon-outgoing snclient-wise-rejected">
                                                      <i className="ri-space-ship-line"></i>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    {/* Rejected */}
                                  </div>
                                  {/* Period 2 */}
                                  <div className="col-lg-6 mb-4">
                                    <div className="period-header">
                                      <i className="fas fa-check-square checkbox-icon" />
                                      <strong>Period 2:</strong>{" "}
                                      <span className="text-danger">
                                        {selectionMode === "month"
                                          ? monthPeriod2Name
                                          : recordingSummary?.summary
                                              ?.period2Summary?.dateRange}
                                      </span>
                                    </div>
                                    <div>
                                      {/* Accordion Header */}
                                      <div className="col-md-12 col-sm-6">
                                        <div className="row">
                                          <div className="col-md-12">
                                            <div className="sn-client-wise-total-data">
                                              <div
                                                className="stat-number text-info"
                                                style={{
                                                  marginTop: "50px",
                                                  display: "inline-block",
                                                }}
                                              >
                                                {
                                                  recordingSummary?.summary
                                                    ?.period2Summary?.total
                                                }
                                              </div>
                                              <p className="stat-label">
                                                Total
                                              </p>
                                            </div>
                                          </div>
                                        </div>

                                        {/* Accordion Collapse Body */}
                                        <div className="row">
                                          <div className="col-md-12">
                                            {/* Place your Period 2 content here */}
                                            <div className="row">
                                              {/* Outgoing */}
                                              <div className="col-md-6">
                                                <div className="stat-card bg-white outgoing-border">
                                                  <div className="sn-client-wise-icon-box ">
                                                    <div>
                                                      <p className="stat-label">
                                                        Outgoing
                                                      </p>
                                                      <div className="stat-number text-success">
                                                        {
                                                          recordingSummary
                                                            ?.summary
                                                            ?.period2Summary
                                                            ?.outgoing
                                                        }
                                                      </div>
                                                    </div>

                                                    <div>
                                                      <div className="sn-client-wise-icon-outgoing snclient-wise-outgoing">
                                                        <i className="ri-space-ship-line"></i>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              {/* Incoming */}
                                              <div className="col-md-6">
                                                <div className="stat-card bg-white incoming-border">
                                                  <div className="sn-client-wise-icon-box ">
                                                    <div>
                                                      <p className="stat-label">
                                                        Incoming
                                                      </p>
                                                      <div className="stat-number text-primary">
                                                        {
                                                          recordingSummary
                                                            ?.summary
                                                            ?.period2Summary
                                                            ?.incoming
                                                        }
                                                      </div>
                                                    </div>

                                                    <div>
                                                      <div className="sn-client-wise-icon-outgoing snclient-wise-incoming">
                                                        <i className="ri-space-ship-line"></i>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              {/* Missed */}
                                              <div className="col-md-6">
                                                <div className="stat-card bg-white missed-border">
                                                  <div className="sn-client-wise-icon-box ">
                                                    <div>
                                                      <p className="stat-label">
                                                        Missed
                                                      </p>
                                                      <div className="stat-number text-danger">
                                                        {
                                                          recordingSummary
                                                            ?.summary
                                                            ?.period2Summary
                                                            ?.missed
                                                        }
                                                      </div>
                                                    </div>

                                                    <div>
                                                      <div className="sn-client-wise-icon-outgoing snclient-wise-missed">
                                                        <i className="ri-space-ship-line"></i>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              {/* Rejected */}
                                              <div className="col-md-6">
                                                <div className="stat-card bg-white rejected-border">
                                                  <div className="sn-client-wise-icon-box ">
                                                    <div>
                                                      <p className="stat-label">
                                                        Rejected
                                                      </p>
                                                      <div className="stat-number text-muted">
                                                        {
                                                          recordingSummary
                                                            ?.summary
                                                            ?.period2Summary
                                                            ?.rejected
                                                        }
                                                      </div>
                                                    </div>
                                                    <div>
                                                      <div className="sn-client-wise-icon-outgoing snclient-wise-rejected">
                                                        <i className="ri-space-ship-line"></i>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              {/* Total */}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* Overall Change Section */}
                                <div className="row">
                                  <div className="col-12">
                                    <div className="period-header">
                                      <i className="fas fa-check-square checkbox-icon" />
                                      <strong>Overall Change</strong>
                                    </div>
                                    <div className="sn-client-overall-change-overall">
                                      {/* Outgoing Change */}
                                      <div className="">
                                        <div className="change-card outgoing-border">
                                          <div className="sn-client-wise-icon-box2">
                                            <div>
                                              <div className="change-number negative-change">
                                                {
                                                  recordingSummary?.summary
                                                    ?.overallDifference
                                                    ?.outgoing
                                                }
                                              </div>

                                              <p className="change-label">
                                                Outgoing
                                              </p>
                                            </div>

                                            <div>
                                              <div
                                                className={`fs-13 fw-medium mb-0 text-${
                                                  recordingSummary?.summary
                                                    ?.overallPercentageChange
                                                    ?.outgoing >= 0
                                                    ? "success"
                                                    : "danger"
                                                }`}
                                              >
                                                {
                                                  recordingSummary?.summary
                                                    ?.overallPercentageChange
                                                    ?.outgoing
                                                }
                                                %
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/* Incoming Change */}
                                      <div className="">
                                        <div className="change-card incoming-border">
                                          <div className="sn-client-wise-icon-box2">
                                            <div>
                                              <div className="change-number negative-change">
                                                {
                                                  recordingSummary?.summary
                                                    ?.overallDifference
                                                    ?.incoming
                                                }
                                              </div>
                                              <p className="change-label">
                                                Incoming
                                              </p>
                                            </div>

                                            <div>
                                              <div
                                                className={`fs-13 fw-medium mb-0 text-${
                                                  recordingSummary?.summary
                                                    ?.overallPercentageChange
                                                    ?.incoming >= 0
                                                    ? "success"
                                                    : "danger"
                                                }`}
                                              >
                                                {
                                                  recordingSummary?.summary
                                                    ?.overallPercentageChange
                                                    ?.incoming
                                                }
                                                %
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/* Missed Change */}
                                      <div className="">
                                        <div className="change-card missed-border">
                                          <div className="sn-client-wise-icon-box2">
                                            <div>
                                              <div className="change-number negative-change">
                                                {
                                                  recordingSummary?.summary
                                                    ?.overallDifference?.missed
                                                }
                                              </div>
                                              <p className="change-label">
                                                Missed
                                              </p>
                                            </div>
                                            <div>
                                              <div
                                                className={`fs-13 fw-medium mb-0 text-${
                                                  recordingSummary?.summary
                                                    ?.overallPercentageChange
                                                    ?.missed >= 0
                                                    ? "success"
                                                    : "danger"
                                                }`}
                                              >
                                                (
                                                {
                                                  recordingSummary?.summary
                                                    ?.overallPercentageChange
                                                    ?.missed
                                                }
                                                %)
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/* Rejected Change */}
                                      <div className="">
                                        <div className="change-card rejected-border">
                                          <div className="sn-client-wise-icon-box2">
                                            <div>
                                              <div className="change-number negative-change">
                                                {
                                                  recordingSummary?.summary
                                                    ?.overallDifference
                                                    ?.rejected
                                                }
                                              </div>
                                              <p className="change-label">
                                                Rejected
                                              </p>
                                            </div>
                                            <div>
                                              <div
                                                className={`fs-13 fw-medium mb-0 text-${
                                                  recordingSummary?.summary
                                                    ?.overallPercentageChange
                                                    ?.rejected >= 0
                                                    ? "success"
                                                    : "danger"
                                                }`}
                                              >
                                                (
                                                {
                                                  recordingSummary?.summary
                                                    ?.overallPercentageChange
                                                    ?.rejected
                                                }
                                                %)
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/* Total Change */}
                                      <div className="">
                                        <div className="change-card total-border">
                                          <div className="sn-client-wise-icon-box2">
                                            <div>
                                              <div className="change-number negative-change">
                                                {
                                                  recordingSummary?.summary
                                                    ?.overallDifference?.total
                                                }
                                              </div>
                                              <p className="change-label">
                                                Total
                                              </p>
                                            </div>
                                            <div>
                                              <div
                                                className={`fs-13 fw-medium mb-0 text-${
                                                  recordingSummary?.summary
                                                    ?.overallPercentageChange
                                                    ?.total >= 0
                                                    ? "success"
                                                    : "danger"
                                                }`}
                                              >
                                                (
                                                {
                                                  recordingSummary?.summary
                                                    ?.overallPercentageChange
                                                    ?.total
                                                }
                                                %)
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>{" "}
                            </>
                          </CardBody>
                        </Col>
                      </Row>

                      <Row className="sn-user-tble-manin-manage mb-0">
                        <Col lg={12} className="sn-team-managment-tble">
                          <Col
                            xxl={2}
                            md={4}
                            className={`ms-auto mt-0 pt-0 ${
                              getTableData && getTableData.length > 0
                                ? "d-block"
                                : "d-none"
                            }`}
                          >
                            <Input
                              id="searchInput"
                              type="text"
                              placeholder="Search by keyword..."
                              value={searchQuery}
                              onChange={handleSearchChange}
                            />
                          </Col>
                          <Col
                            className="employe-report-not-pickup-colum-tbl mt-3"
                            lg={12}
                          >
                            <Grid
                              data={filterData}
                              columns={transformedColumns}
                              sort={true}
                              fixedHeader={true}
                              pagination={{ enabled: true, limit: 20 }}
                              style={{ minWidth: "100%" }}
                            />
                          </Col>

                          {/* <CommanDataTables
                            column={columns}
                            handlePerRowsChange={handlePerRowsChange}
                            isLoading={isLoading}
                            handlePageChange={handlePageChange}
                            showSearch={false}
                            tableData={filterData}
                            totalRows={totalRows}
                            currentPage={currentPage}
                            handleSearch={handleSearch}
                            perPage={perPage}
                          /> */}
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EmployeeWiseClientReport;
